/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, typography } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const BannerWrapper = styled.div`
  height: 124px;
  min-width: 580px;
  padding: ${token('space.300', '24px')};
  border: 1px solid ${token('color.border', colors.N40)};
  border-radius: ${token('space.025', '2px')};
  display: flex;
  flex-direction: row;
  margin-bottom: ${token('space.400', '32px')};

  @media (max-width: 1000px) {
    img {
      display: none;
    }
  }
`;

export const BannerContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 450px;
  margin-right: -100px;
`;

export const BannerTitleWrapper = styled.h2`
  display: flex;
  ${typography.h600() as any};
  color: ${token('color.text', '#172B4D')};
  padding-bottom: ${token('space.100', '8px')};
`;

export const BannerDescriptionWrapper = styled.div`
  display: flex;
  color: ${token('color.text', '#172B4D')};
`;

export const ButtonGroupWrapper = styled.div`
  display: flex;
  margin-top: auto;
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LogoWrapper = styled.div`
  display: flex;
  margin-top: auto;
  align-items: flex-end;
`;

export const DismissWrapper = styled.div`
  display: flex;
  margin-left: auto;
  justify-content: right;
  margin-top: ${token('space.negative.075', '-6px')};
`;

export const BannerImageWrapper = styled.div`
  margin-top: ${token('space.negative.300', '-24px')};
  margin-bottom: ${token('space.negative.300', '-24px')};
  margin-left: auto;
  margin-right: auto;
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${token('space.negative.400', '-32px')};
`;

export const CardContentWrapper = styled.div({
  display: 'flex',
  padding: `${token('space.050', '4px')} 20px 20px 20px`,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: token('space.0', '0px'),
  alignSelf: 'stretch',
  textAlign: 'center',
  minWidth: '216px',
  maxWidth: '360px',
});

export const CardHeader = styled.div({
  display: 'flex',
  paddingBottom: token('space.200', '16px'),
  flexDirection: 'column',
});

export const CardTitleWrapper = styled.h4(typography.h400() as any, {
  marginTop: token('space.0', '0px'),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
});

export const CardDropdownMenu = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  textAlign: 'start',
});

export const CardImgWrapper = styled.div({
  paddingBottom: token('space.150', '12px'),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  width: '100%',
});

export const CardDescriptionWrapper = styled.div({
  display: 'flex',
  color: token('color.text', '#172B4D'),
  paddingBottom: token('space.200', '16px'),
  flexDirection: 'column',
  justifyContent: 'center',
});

export const CardButtonWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  width: '100%',
});
